export class BookingQuotePrestation {
    id: string
    quantity: number
    travellers: number
    constructor(
        id: string,
        quantity: number,
        travellers: number,
    ) {
        this.id = id
        this.quantity = quantity
        this.travellers = travellers
    }
}
export class BookingQuoteTraveller {
    type: string
    birthDate: string
    firstName?: string
    lastName?: string
    constructor(
        type: string,
        birthDate: string,
        firstName?: string,
        lastName?: string,
    ) {
        this.type = type
        this.birthDate = birthDate
        this.firstName = firstName
        this.lastName = lastName
    }
}

export interface IBookingQuoteDTO {
    entity: string
    liheId: string
    season: string
    packageId: string
    prestations: BookingQuotePrestation[]
    startDate: string
    endDate: string
    travellers: BookingQuoteTraveller[]
}


export class BookingQuoteDTO implements IBookingQuoteDTO {
    public entity: string
    public liheId: string
    public season: string
    public packageId: string
    public prestations: BookingQuotePrestation[]
    public startDate: string
    public endDate: string
    public travellers: BookingQuoteTraveller[]

    constructor(
        lihe_id: string,
        travellers: BookingQuoteTraveller[],
        start_date: string,
        end_date: string,
        prestations: BookingQuotePrestation[],
        season: string,
        prest_id: string,
        entity: string,
    ) {
        this.liheId = lihe_id;
        this.travellers = travellers;
        this.startDate = start_date;
        this.endDate = end_date;
        this.prestations = prestations;
        this.season = season
        this.packageId = prest_id
        this.entity = entity
    }

}

export function validateBookingQuotePrestation(data: any): boolean {
    if (typeof data !== "object") {
        console.error("validateBookingQuotePrestation: data is not an object");
        return false;
    }
    if (typeof data.id !== "string") {
        console.error("validateBookingQuotePrestation: id is not a string");
        return false;
    }
    if (typeof data.quantity !== "number") {
        console.error("validateBookingQuotePrestation: quantity is not a number");
        return false;
    }
    if (typeof data.travellers !== "number") {
        console.error("validateBookingQuotePrestation: travellers is not a number");
        return false;
    }
    return true;
}

export function validateBookingQuoteTraveller(data: any): boolean {
    if (typeof data !== "object") {
        console.error("validateBookingQuoteTraveller: data is not an object");
        return false;
    }
    if (typeof data.type !== "string") {
        console.error("validateBookingQuoteTraveller: type is not a string");
        return false;
    }
    if (typeof data.birthDate !== "string") {
        console.error("validateBookingQuoteTraveller: birthDate is not a string");
        return false;
    }
    if (data.firstName !== undefined && typeof data.firstName !== "string") {
        console.error("validateBookingQuoteTraveller: firstName is not undefined and not a string");
        return false;
    }
    if (data.lastName !== undefined && typeof data.lastName !== "string") {
        console.error("validateBookingQuoteTraveller: lastName is not undefined and not a string");
        return false;
    }
    return true;
}

export function validateIBookingQuoteDTO(data: any): boolean {
    if (typeof data !== "object") {
        console.error("validateIBookingQuoteDTO: data is not an object");
        return false;
    }
    if (typeof data.entity !== "string") {
        console.error("validateIBookingQuoteDTO: entity is not a string");
        return false;
    }
    if (typeof data.liheId !== "string") {
        console.error("validateIBookingQuoteDTO: liheId is not a string");
        return false;
    }
    if (typeof data.season !== "string") {
        console.error("validateIBookingQuoteDTO: season is not a string");
        return false;
    }
    if (typeof data.packageId !== "string") {
        console.error("validateIBookingQuoteDTO: packageId is not a string");
        return false;
    }
    if (!Array.isArray(data.prestations) || !data.prestations.every((prestation: any) => validateBookingQuotePrestation(prestation))) {
        console.error("validateIBookingQuoteDTO: prestations is not a valid array of BookingQuotePrestation objects");
        return false;
    }
    if (typeof data.startDate !== "string") {
        console.error("validateIBookingQuoteDTO: startDate is not a string");
        return false;
    }
    if (typeof data.endDate !== "string") {
        console.error("validateIBookingQuoteDTO: endDate is not a string");
        return false;
    }
    if (!Array.isArray(data.travellers) || !data.travellers.every((traveller: any) => validateBookingQuoteTraveller(traveller))) {
        console.error("validateIBookingQuoteDTO: travellers is not a valid array of BookingQuoteTraveller objects");
        return false;
    }
    return true;
}

export function buildBookingQuotePrestation(data: any): BookingQuotePrestation {
    if (!validateBookingQuotePrestation(data)) throw new Error("Invalid BookingQuotePrestation object")
    return new BookingQuotePrestation(
        data.id,
        data.quantity,
        data.travellers
    );
}

export function buildBookingQuoteTraveller(data: any): BookingQuoteTraveller {
    if (!validateBookingQuoteTraveller(data)) throw new Error("Invalid BookingQuoteTraveller object")
    return new BookingQuoteTraveller(
        data.type,
        data.birthDate,
        data.firstName,
        data.lastName
    );
}

export function buildIBookingQuoteDTO(data: any): IBookingQuoteDTO {
    if (!validateIBookingQuoteDTO(data)) throw new Error("Invalid IBookingQuoteDTO object")
    return new BookingQuoteDTO(
        data.liheId,
        data.travellers.map((traveller: any) => buildBookingQuoteTraveller(traveller)),
        data.startDate,
        data.endDate,
        data.prestations.map((prestation: any) => buildBookingQuotePrestation(prestation)),
        data.season,
        data.packageId,
        data.entity
    );
}
